<template>
  <v-card flat>
    <v-dialog
      :fullscreen="isMobileBreakpoint"
      persistent
      v-model="openModal"
      width="600px"
    >
      <div class="dialogIframe">
        <v-toolbar elevation="0">
          <v-toolbar-title class="text--subtitle ml-2">
            {{ $t('message.pages.video.buttonsPage.titleOutsideButton') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="handleGetBack()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <iframe
          id="preview-iframe"
          style="width: 91%; border: none; background: white; margin-left: 24px"
        ></iframe>
      </div>
      <v-card>
        <v-card-text class="mr-3">
          <v-row no-gutters>
            <v-col cols="12" class="my-1 body-bold-base neutral-20-dark-text">
              {{ $t('message.pages.video.buttonsPage.display') }}</v-col
            >
            <v-col cols="12" class="mt-2">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div style="display: grid">
                    <span class="neutral-20-dark-text">
                      {{ $t('message.pages.video.buttonsPage.showButton') }}
                    </span>
                    <span class="body-regular-smaller">
                      {{
                        $t('message.pages.video.buttonsPage.showButtonExplain')
                      }}
                    </span>
                  </div>
                  <v-tooltip
                    top
                    :disabled="
                      !containButton.length || initialEditingButton.lastAllVideo
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on" v-bind="attrs">
                        <v-switch
                          v-model="editingButton.lastAllVideo"
                          color="primary"
                          class="ma-0 toggle-input"
                          hide-details
                          :disabled="
                            containButton.length > 0 &&
                            !initialEditingButton.lastAllVideo
                          "
                          @click="handleLastAllVideo"
                        ></v-switch>
                      </div>
                    </template>
                    <span>{{
                      $t('message.pages.video.buttonsPage.disableAllTime')
                    }}</span>
                  </v-tooltip>
                </v-row>
              </v-col>
            </v-col>

            <v-col cols="12" class="mt-2">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div style="display: grid">
                    <span class="neutral-20-dark-text">{{
                      $t(
                        'message.pages.video.buttonsPage.showButtonSpecificTime'
                      )
                    }}</span>
                    <span class="body-regular-smaller">{{
                      $t(
                        'message.pages.video.buttonsPage.showButtonSpecificTimeExplain'
                      )
                    }}</span>
                  </div>
                  <v-switch
                    v-model="openModalExceptTime"
                    color="primary"
                    class="ma-0 toggle-input"
                    hide-details
                    @change="handleOpenModalExceptTime"
                  ></v-switch>
                </v-row>
              </v-col>
            </v-col>
            <v-col cols="12" class="mt-4 mb-1" v-if="openModalExceptTime">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                  class="mb-3"
                >
                  <span class="neutral-20-dark-text">
                    {{ $t('message.pages.video.buttonsPage.init') }}
                  </span>
                  <!-- start -->
                  <AntTimePicker
                    :startVal="editingButton.startTime"
                    class="hide-icon-time-picker"
                    :timeVideo="timeVideo"
                    :class="{ 'error-timer': checkIfIsBetweenInterval }"
                    :currentVal="editingButton.startTime"
                    :disabled="editingButton.lastAllVideo"
                    @changedTime="
                      (time) =>
                        (editingButton.startTime = time) && setIframeConfig()
                    "
                  />
                </v-row>

                <v-row
                  class="mt-2"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">{{
                    $t('message.pages.video.buttonsPage.end')
                  }}</span>
                  <AntTimePicker
                    class="hide-icon-time-picker"
                    :key="
                      isLowerOrEqual
                        ? editingButton.startTime
                        : editingButton.endTime
                    "
                    :class="{ 'error-timer': checkIfIsBetweenInterval }"
                    :startVal="
                      isLowerOrEqual
                        ? editingButton.startTime
                        : editingButton.endTime
                    "
                    :thresholdTime="minEndTime"
                    :timeVideo="timeVideo"
                    :currentVal="editingButton.endTime"
                    :disabled="
                      editingButton.lastAllVideo || editingButton.lastTillEnd
                    "
                    @changedTime="
                      (time) =>
                        (editingButton.endTime = time) && setIframeConfig()
                    "
                  />
                </v-row>
                <v-row v-if="checkIfIsBetweenInterval" class="mt-6">
                  <v-spacer />
                  <span class="body-regular-smaller error_text">
                    {{ $t('message.pages.video.buttonsPage.containsButton') }}
                  </span>
                </v-row>
              </v-col>
            </v-col>
            <v-col v-if="openModalExceptTime" cols="12" class="mt-2">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div style="display: grid">
                    <span class="neutral-20-dark-text">{{
                      $t('message.pages.video.buttonsPage.atTheEnd')
                    }}</span>
                  </div>
                  <v-switch
                    v-model="editingButton.lastTillEnd"
                    color="primary"
                    class="ma-0 toggle-input"
                    hide-details
                    @change="handleLastTillEnd"
                  ></v-switch>
                </v-row>
              </v-col>
            </v-col>
            <v-col cols="12"><v-divider class="my-4"></v-divider></v-col>
            <v-col cols="12">
              <span class="body-bold-base neutral-20-dark-text">{{
                $t('message.pages.video.buttonsPage.general')
              }}</span>
            </v-col>
            <v-col cols="12" class="mt-2">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div style="display: grid">
                    <span class="neutral-20-dark-text">{{
                      $t('message.pages.video.buttonsPage.customHtml')
                    }}</span>
                    <span class="body-regular-smaller"
                      ><a
                        :href="
                          $t('message.pages.video.buttonsPage.howToUseLink')
                        "
                        target="_blank"
                        style="text-decoration: none"
                      >
                        <b class="redirectLink"
                          >{{ $t('message.pages.video.buttonsPage.howToUse') }}
                        </b>
                        <v-icon
                          size="12"
                          style="vertical-align: middle; display: inline"
                          >mdi-open-in-new</v-icon
                        ></a
                      ></span
                    >
                  </div>
                  <v-switch
                    v-model="editingButton.isCustomHtml"
                    color="primary"
                    class="ma-0 toggle-input"
                    hide-details
                    @change="setIframeConfig"
                  ></v-switch>
                </v-row>
              </v-col>
            </v-col>
            <v-col cols="12" class="mt-2" v-if="!editingButton.isCustomHtml">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">{{
                    $t('message.pages.video.buttonsPage.buttonText')
                  }}</span>
                  <v-col cols="6">
                    <v-input
                      v-model="editingButton.title"
                      dense
                      outlined
                      hide-details
                      color="primary"
                      :placeholder="$t('message.pages.video.buttonsPage.add')"
                      @input="setIframeConfig"
                    ></v-input>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>

            <v-col cols="12" class="mt-2" v-if="!editingButton.isCustomHtml">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">{{
                    $t('message.pages.video.buttonsPage.link')
                  }}</span>
                  <v-col cols="6">
                    <v-input
                      :error="checkDomainRegex"
                      v-model="editingButton.link"
                      dense
                      outlined
                      hide-details
                      color="primary"
                      placeholder="http://"
                      @input="setIframeConfig"
                      :rules="[buttonsValidations.link]"
                    ></v-input>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
            <v-col v-if="checkDomainRegex" cols="12">
              <v-col class="py-0">
                <span
                  class="red--text caption align-text"
                  style="display: flex; justify-content: flex-end"
                >
                  {{ $t('message.pages.video.thumbnails.regexWarning') }}
                </span>
              </v-col>
            </v-col>
            <v-col cols="12" v-if="!editingButton.isCustomHtml">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">{{
                    $t('message.pages.video.buttonsPage.size')
                  }}</span>
                  <v-col cols="6">
                    <v-select
                      v-model="editingButton.selectedButtonSize"
                      dense
                      outlined
                      hide-details
                      color="primary"
                      :items="
                        $t('message.pages.video.buttonsPage.sizeChoise', {
                          returnObjects: true,
                        })
                      "
                      item-value="value"
                      item-text="label"
                      @change="setIframeConfig"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>

            <v-col cols="12" class="mt-2" v-if="!editingButton.isCustomHtml">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">{{
                    $t('message.pages.video.buttonsPage.textColor')
                  }}</span>
                  <span style="margin-right: 3px; margin-left: auto">{{
                    editingButton.textColor
                  }}</span>
                  <v-col cols="1">
                    <v-menu
                      offset-x
                      top
                      nudge-bottom="105"
                      nudge-left="16"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :color="editingButton.textColor"
                          v-on="on"
                          icon
                          :style="setTextColorMenu"
                          elevation="3"
                          style="height: 16px; width: 16px"
                          class="rounded-circle"
                        ></v-btn>
                      </template>
                      <v-color-picker
                        v-model="editingButton.textColor"
                        elevation="3"
                        flat
                        mode="hexa"
                        hide-mode-switch
                        @input="setIframeConfig"
                      ></v-color-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
            <v-col cols="12" class="mt-2" v-if="!editingButton.isCustomHtml">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div style="display: grid">
                    <span class="neutral-20-dark-text"
                      >{{ $t('message.pages.video.buttonsPage.textColor') }} (
                      Hover )</span
                    >
                    <span class="body-regular-smaller">
                      {{
                        $t(
                          'message.pages.video.buttonsPage.alterColorWhenInteract'
                        )
                      }}
                    </span>
                  </div>
                  <span style="margin-right: 3px; margin-left: auto">{{
                    editingButton.textHover
                  }}</span>
                  <v-col cols="1">
                    <v-menu
                      offset-x
                      top
                      nudge-bottom="105"
                      nudge-left="16"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :color="editingButton.textHover"
                          v-on="on"
                          icon
                          :style="setTextHoverColorMenu"
                          elevation="3"
                          style="height: 16px; width: 16px"
                          class="rounded-circle"
                        ></v-btn>
                      </template>
                      <v-color-picker
                        v-model="editingButton.textHover"
                        elevation="3"
                        flat
                        mode="hexa"
                        hide-mode-switch
                        @input="setIframeConfig"
                      ></v-color-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>

            <v-col cols="12" class="mt-2" v-if="!editingButton.isCustomHtml">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">{{
                    $t('message.pages.video.buttonsPage.backgroundColor')
                  }}</span>
                  <span style="margin-right: 3px; margin-left: auto">{{
                    editingButton.backgroundColor
                  }}</span>
                  <v-col cols="1">
                    <v-menu
                      offset-x
                      top
                      nudge-bottom="105"
                      nudge-left="16"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :color="editingButton.backgroundColor"
                          v-on="on"
                          icon
                          elevation="3"
                          :style="setBackgroundColorMenu"
                          style="height: 16px; width: 16px"
                          class="rounded-circle"
                        ></v-btn>
                      </template>
                      <v-color-picker
                        v-model="editingButton.backgroundColor"
                        elevation="3"
                        flat
                        mode="hexa"
                        hide-mode-switch
                        @input="setIframeConfig"
                      ></v-color-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>

            <v-col cols="12" class="mt-2" v-if="!editingButton.isCustomHtml">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text"
                    >{{
                      $t('message.pages.video.buttonsPage.backgroundColor')
                    }}
                    ( Hover )</span
                  >
                  <span style="margin-right: 3px; margin-left: auto">{{
                    editingButton.backgroundHover
                  }}</span>
                  <v-col cols="1">
                    <v-menu
                      offset-x
                      top
                      nudge-bottom="105"
                      nudge-left="16"
                      :close-on-content-click="true"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :color="editingButton.backgroundHover"
                          v-on="on"
                          icon
                          :style="setBackgroundHoverColorMenu"
                          elevation="3"
                          style="height: 16px; width: 16px"
                          class="rounded-circle"
                        ></v-btn>
                      </template>
                      <v-color-picker
                        elevation="3"
                        v-model="editingButton.backgroundHover"
                        flat
                        mode="hexa"
                        hide-mode-switch
                        :maxlength="7"
                        @input="setIframeConfig"
                      ></v-color-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>

          <v-col col="12" class="mt-3" v-if="!editingButton.isCustomHtml">
            <v-row
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div style="display: grid">
                <span class="neutral-20-dark-text">{{
                  $t('message.pages.video.buttonsPage.sendParameterInUrl')
                }}</span>
                <span style="font-size: 12px; font-family: Rubik">{{
                  $t(
                    'message.pages.video.buttonsPage.sendParameterInURlExplain'
                  )
                }}</span>
                <span class="body-regular-smaller"
                  ><a
                    :href="$t('message.pages.video.buttonsPage.knowMoreURL')"
                    target="_blank"
                    style="text-decoration: none"
                  >
                    <b class="redirectLink"
                      >{{ $t('message.pages.video.buttonsPage.knowMore') }}
                    </b>
                    <v-icon
                      size="12"
                      style="vertical-align: middle; display: inline"
                      >mdi-open-in-new</v-icon
                    ></a
                  ></span
                >
              </div>
              <v-switch
                v-model="editingButton.appendWebsiteQueryParams"
                color="primary"
                class="ma-0 toggle-input"
                hide-details
              ></v-switch>
            </v-row>
          </v-col>

          <v-row no-gutters class="mt-6" v-if="editingButton.isCustomHtml">
            <v-col cols="12" class="mb-2">
              {{ $t('message.pages.videoPlayerButtons.htmlCode') }}
            </v-col>
            <v-col cols="12">
              <v-textarea-legacy
                v-model="editingButton.codeHtml"
                :placeholder="$t('message.pages.video.buttonHtmlText')"
                outlined
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <div class="py-6 pr-7 actionsBtns">
        <base-btn
          type="tertiary"
          class="mr-2"
          min-width="150"
          @click="discardChanges"
        >
          {{ $t('message.actions.cancel') }}
        </base-btn>
        <v-tooltip bottom :disabled="!withoutChanges">
          <template v-slot:activator="{ on, attrs }">
            <base-btn
              v-bind="attrs"
              v-on="on"
              min-width="150"
              @click="handlePublishNewCta"
              :disabled="
                disablePublishButton ||
                withoutChanges ||
                checkDomainRegex ||
                checkIfIsBetweenInterval
              "
              :loading="loadings.creatingCta || loadings.updatingCta"
              >{{ $t('message.pages.videoPlayerButtons.publish') }}
            </base-btn>
          </template>
          <span>{{ $t('message.noChanges') }}</span>
        </v-tooltip>
      </div>
    </v-dialog>
  </v-card>
</template>

<script>
/* eslint-disable */

// external imports
import { v4 as uuidv4 } from 'uuid'
import { mapActions, mapMutations, mapState } from 'vuex'
import _ from 'lodash'

// API
import playerApi from '@/services/playerApi'

// Components
import LearnMoreBtn from '@/components/LearnMoreBtn.vue'
import AntTimePicker from '@/components/AntTimePicker.vue'
import BaseBtn from '@/components/BaseBtn.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import embedPageMixin from '@/utils/embedPage.mixin.js'
export default {
  name: 'VideoPlayerAddButton',
  components: {
    LearnMoreBtn,
    AntTimePicker,
    BaseBtn,
    BaseAlert,
  },
  props: { handleUpdateVideo: { type: Function, require: true } },
  mixins: [embedPageMixin],
  data: () => ({
    isEditing: false,
    timeVideo: null,
    embedIframe: null,
    openModal: false,
    error: '',
    beingEditedCtaId: '',
    openModalExceptTime: false,
    buttonScript: null,
    initialEditingButton: {},
    editingButton: {
      title: '',
      link: '',
      startTime: '00:00',
      endTime: '00:05',
      selectedButtonType: 'underVideo',
      textColor: '#FFFFFF',
      textHover: '#FFFFFF',
      backgroundColor: '#3e50f7',
      backgroundHover: '#3e50f7',
      selectedButtonSize: 'small',
      selectedButtonPlacement: 'bottomCenter',
      isCustomHtml: false,
      codeHtml: '',
      lastAllVideo: true,
      lastTillEnd: false,
      keepWindow: false,
      appendWebsiteQueryParams: false,
    },
    buttonPlacements: [
      { type: 'topLeft', text: 'Topo a esquerda' },
      { type: 'topCenter', text: 'Topo centralizado' },
      { type: 'topRight', text: 'Topo a direita' },
      { type: 'midLeft', text: 'Meio a esquerda' },
      { type: 'midCenter', text: 'Meio centralizado' },
      { type: 'midRight', text: 'Meio a direita' },
      { type: 'bottomLeft', text: 'Fundo a esquerda' },
      { type: 'bottomCenter', text: 'Fundo centralizado' },
      { type: 'bottomRight', text: 'Fundo a direita' },
    ],
    loadings: {
      creatingCta: false,
      updatingCta: false,
      removingCta: false,
    },
    buttonsValidations: {
      link: (value) => {
        if (value.length) return true
        if (value.length < 2) return false
        return false
      },
    },
  }),
  created() {
    this.$root.$on('openModalExternalButton', (data) => {
      if (data) {
        if (data?.id) {
          this.initialEditingCtaValue = JSON.parse(JSON.stringify(data))
          this.beingEditedCtaId = data.id
          this.editingButton = data.metadata
          this.fixAppendWebsiteVal()
        } else {
          if (this.timeVideo >= 3600) {
            this.editingButton.startTime = '00:00:00'
            this.editingButton.endTime = '00:05:00'
          }
        }
        this.isEditing = true
        this.$nextTick(() => {
          this.setIframeConfig()
        })
        this.wasSomethingChanged = false
        if (!this.editingButton.lastAllVideo) {
          this.handleOpenModalExceptTime(true)
        }
        this.editingButton.selectedButtonType = 'underVideo'
        this.openModal = true
      } else {
        this.editingButton.selectedButtonType = 'underVideo'
        this.openModal = true
      }
    })
  },
  mounted() {
    this.timeVideo = this.$store.state.video.video?.length
    this.editingButton.title = this.$t('message.pages.video.button')

    this.initialEditingButton = _.cloneDeep(this.editingButton)
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    disablePublishButton() {
      return (
        this.loadings.creatingCta ||
        this.loadings.updatingCta ||
        !this.editingButton.link ||
        !this.editingButton.title ||
        !((this.editingButton.link || '').length > 2)
      )
    },
    isLowerOrEqual() {
      const { endTime, startTime } = this.editingButton
      return endTime < startTime
    },
    setTextColorMenu() {
      return {
        backgroundColor: this.editingButton.textColor,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    withoutChanges() {
      return _.isEqual(this.editingButton, this.initialEditingButton)
    },
    setTextHoverColorMenu() {
      return {
        backgroundColor: this.editingButton.textHover,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    setBackgroundColorMenu() {
      return {
        backgroundColor: this.editingButton.backgroundColor,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    setBackgroundHoverColorMenu() {
      return {
        backgroundColor: this.editingButton.backgroundHover,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    minEndTime() {
      return this.blockingEndTime()
    },
    isVertical() {
      return this.video.height > this.video.width
    },
    containButton() {
      return this.video?.config?.outsideCta ?? []
    },
    checkDomainRegex() {
      let link = this.editingButton.link ?? ''
      if (link.length < 2) {
        return false
      }
      const pattern = new RegExp(
        /^(https?):\/\/([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/
      )
      return !pattern.test(link)
    },
    checkIfIsBetweenInterval: {
      get() {
        if (this.isEditing) return false
        if (!this.editingButton.startTime && this.editingButton.startTime !== 0)
          return false
        let hasNewThumbCreated = false
        const ctas = this.video?.config?.ctas || []
        let x = ctas.map((el) => {
          if (el.id === this.editingButton.id) return { start: -1, end: -1 }
          if (
            !hasNewThumbCreated &&
            (this.formatTimeToSeconds(el.metadata.startTime) ||
              this.formatTimeToSeconds(el.metadata.endTime))
          ) {
            hasNewThumbCreated = true
          }
          return {
            start: this.formatTimeToSeconds(el.metadata.startTime),
            end: this.formatTimeToSeconds(el.metadata.endTime),
          }
        })
        let result = []
        let z = {
          start: this.formatTimeToSeconds(this.editingButton.startTime),
          end: this.formatTimeToSeconds(this.editingButton.endTime),
        }
        if (hasNewThumbCreated) {
          result = x.filter(
            (i) =>
              this.inRange(z.start, i.start, i.end) ||
              this.inRange(z.end, i.start, i.end)
          )
        } else {
          result = x.filter(
            (i) =>
              this.inRange(z.start, i.start, i.end) ||
              this.inRange(z.end, i.start, i.end)
          )
        }
        return !!result.length
      },
      deep: true,
      cache: false,
    },
  },
  methods: {
    ...mapActions('video', [
      'updateCta',
      'getVideoConfig',
      'createProfile',
      'setProfileToVideos',
      ,
    ]),
    ...mapMutations('video', [
      'UPDATE_VIDEO',
      'UPDATE_STATUS_ERROR',
      'UPDATE_VIDEO_CONFIG_CTAS',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    fixAppendWebsiteVal() {
      this.initialAppendWebsite = this.editingButton.appendWebsiteQueryParams
    },
    formatTime(timeString) {
      if (!timeString) return '00:00'

      const totalSeconds = parseFloat(timeString)
      const minutes = Math.floor(totalSeconds / 60)
      const seconds = Math.floor(totalSeconds % 60)

      const formattedMinutes = String(minutes).padStart(2, '0')
      const formattedSeconds = String(seconds).padStart(2, '0')

      return `${formattedMinutes}:${formattedSeconds}`
    },
    formatSecondsToTime(seconds) {
      if (!seconds) return '00:00'
      let res = new Date(seconds * 1000).toISOString()
      if (this.timeVideo < 3600) {
        return res.substring(14, 19)
      }
      return res.substring(11, 19)
    },
    async setIframeConfig() {
      this.wasSomethingChanged = true
      const cta = await this.generateEditingCta()
      const iframe =
        document.getElementById('preview-iframe')?.contentWindow.document ||
        document.getElementById('preview-iframe')?.contentDocument
      if (iframe) {
        iframe.open()
        iframe.write(cta.scriptForPast)
        iframe.write(cta.script)
        iframe.write(`<style>
                      body {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      }
                    </style>`)
        iframe.close()
      }
    },
    async generateEditingCta() {
      let time = Number(this.formatTimeToSeconds(this.editingButton.startTime))
      let duration = Number(
        this.formatTimeToSeconds(this.editingButton.endTime) -
          this.formatTimeToSeconds(this.editingButton.startTime)
      )
      if (
        duration < 1 ||
        !this.editingButton.endTime ||
        this.editingButton.endTime === '0' ||
        this.editingButton.lastTillEnd
      ) {
        duration = this.timeVideo
      }
      if (this.editingButton.lastAllVideo) {
        time = 0
        duration = this.timeVideo
      }
      let cta = {
        id: uuidv4(),
        title: this.editingButton.title,
        type: this.buttonType,
        time: time,
        duration: duration,
        scriptForPast: this.generateOutsideButtonScript(),
        script: this.generateOutsideButtonScriptStyle(),
        metadata: this.editingButton,
      }
      return cta
    },
    formatTimeToSeconds(time) {
      if (typeof time !== 'string') return
      let res = time.split(':').reduce((acc, time) => 60 * acc + +time)
      return res
    },
    generateOutsideButtonScript(placementFlag) {
      let buttonConfig = this.editingButton
      let btnAlignment
      let btnType = buttonConfig.selectedButtonPlacement?.toLowerCase()
      let btnQueries
      if (buttonConfig.selectedButtonType === 'underVideo') {
        btnAlignment = 'justify-content:center; align-items: center'
      } else {
        if (btnType.includes('left')) btnAlignment = 'justify-content:left'
        if (btnType.includes('center')) btnAlignment = 'justify-content:center'
        if (btnType.includes('right')) btnAlignment = 'justify-content:right'
        if (btnType.includes('top')) btnAlignment += ';align-items:start'
        if (btnType.includes('mid')) btnAlignment += ';align-items:center'
        if (btnType.includes('bottom')) btnAlignment += ';align-items:end'
      }
      let btnMeasurements
      let btnSizeType = buttonConfig.selectedButtonSize
      if (btnSizeType === 'small')
        btnMeasurements = 'padding: 18px 54px;font-size:16px;'
      if (btnSizeType === 'medium')
        btnMeasurements = 'padding: 22px 66px;font-size:22px;'
      if (btnSizeType === 'large')
        btnMeasurements = 'padding: 26px 78px;font-size:26px;'
      if (btnSizeType === 'medium' || btnSizeType === 'large') {
        let paddings = this.getButtonPaddings(btnSizeType)
        btnQueries = paddings.mediaQueries
      }
      let scriptMargin
      if (btnType.includes('topleft')) scriptMargin = 'margin:30px'
      if (btnType.includes('topcenter')) scriptMargin = 'margin:30px'
      if (btnType.includes('topright')) scriptMargin = 'margin:30px'
      if (btnType.includes('midleft')) scriptMargin = 'margin: 0px 30px'
      if (btnType.includes('midcenter')) scriptMargin = 'margin: 0px'
      if (btnType.includes('midright')) scriptMargin = 'margin: 0px 30px'
      if (btnType.includes('bottomleft')) scriptMargin = 'margin: 75px 30px'
      if (btnType.includes('bottomcenter')) scriptMargin = 'margin: 75px 30px'
      if (btnType.includes('bottomright')) scriptMargin = 'margin: 75px 30px'
      if (buttonConfig.selectedButtonType === 'underVideo') scriptMargin = ''
      if (placementFlag) scriptMargin = 'margin: 30px 0px 10px 0px'
      /* eslint-disable quotes */
      let generatedScript = `${
        placementFlag === 'outsideBtn'
          ? ''
          : `<script>if (!document.querySelector('script[src="https://player.pandavideo.com.br/api.v2.js"]')) { let s = document.createElement('script'); s.src = 'https://player.pandavideo.com.br/api.v2.js'; s.async = true; document.head.appendChild(s); } window.pandascripttag = window.pandascripttag || []; window.pandascripttag.push(function () { const p = new PandaPlayer('panda-${this.video.video_external_id}', { onReady() { p.loadButtonInTime({ fetchApi: true }) } }); })</scr`
      }`
      /* eslint-enable quotes */
      return generatedScript
    },
    generateOutsideButtonScriptStyle(placementFlag) {
      let buttonConfig = this.editingButton
      let btnAlignment
      let btnType = buttonConfig.selectedButtonPlacement.toLowerCase()
      let btnQueries
      if (buttonConfig.selectedButtonType === 'underVideo') {
        btnAlignment = 'justify-content:center; align-items: center'
      } else {
        if (btnType.includes('left')) btnAlignment = 'justify-content:left'
        if (btnType.includes('center')) btnAlignment = 'justify-content:center'
        if (btnType.includes('right')) btnAlignment = 'justify-content:right'
        if (btnType.includes('top')) btnAlignment += ';align-items:start'
        if (btnType.includes('mid')) btnAlignment += ';align-items:center'
        if (btnType.includes('bottom')) btnAlignment += ';align-items:end'
      }
      let btnMeasurements
      let btnSizeType = buttonConfig.selectedButtonSize
      if (btnSizeType === 'small')
        btnMeasurements = 'padding: 18px 54px;font-size:16px;'
      if (btnSizeType === 'medium')
        btnMeasurements = 'padding: 22px 66px;font-size:22px;'
      if (btnSizeType === 'large')
        btnMeasurements = 'padding: 26px 78px;font-size:26px;'
      if (btnSizeType === 'medium' || btnSizeType === 'large') {
        let paddings = this.getButtonPaddings(btnSizeType)
        btnQueries = paddings.mediaQueries
      }
      let scriptMargin
      if (btnType.includes('topleft')) scriptMargin = 'margin:30px'
      if (btnType.includes('topcenter')) scriptMargin = 'margin:30px'
      if (btnType.includes('topright')) scriptMargin = 'margin:30px'
      if (btnType.includes('midleft')) scriptMargin = 'margin: 0px 30px'
      if (btnType.includes('midcenter')) scriptMargin = 'margin: 0px'
      if (btnType.includes('midright')) scriptMargin = 'margin: 0px 30px'
      if (btnType.includes('bottomleft')) scriptMargin = 'margin: 75px 30px'
      if (btnType.includes('bottomcenter')) scriptMargin = 'margin: 75px 30px'
      if (btnType.includes('bottomright')) scriptMargin = 'margin: 75px 30px'
      if (buttonConfig.selectedButtonType === 'underVideo') scriptMargin = ''
      if (placementFlag) scriptMargin = 'margin: 30px 0px 10px 0px'
      /* eslint-disable quotes */
      let generatedScript = `${
        placementFlag === 'outsideBtn'
          ? ''
          : (this.buttonScript =
              `<script>function pause(){window.parent.postMessage({type: 'pause',}, '*')};
      function redirect(){window.open('${buttonConfig.link}')};
      document.getElementById("button-container").addEventListener("click", function(e) {if (e.target == this) {window.parent.postMessage({type: 'play_toggle',}, '*')}})
      </scr` +
              'ipt>' +
              '<st' +
              `yle> .buttonConfig { cursor:pointer; margin-top:1rem; background-color:${
                buttonConfig.backgroundColor
              };
      color:${
        buttonConfig.textColor
      }; ${btnMeasurements}; border:none; border-radius:10px;}
      .buttonConfig:hover {background-color:${
        buttonConfig.backgroundHover
      };color:${buttonConfig.textHover}}
        ${btnQueries ?? ''}
      </style>
      <button class="buttonConfig" onclick="pause()&redirect()"><b>${
        buttonConfig.title
      }</b></button></div>`)
      }`
      /* eslint-enable quotes */
      return generatedScript
    },

    inRange(x, min, max) {
      return (x - min) * (x - max) <= 0
    },
    getButtonPaddings(btnSizeType) {
      let btnPaddings
      let sizes
      if (btnSizeType === 'small') {
        return ''
      }
      if (btnSizeType === 'medium') {
        sizes = {
          width: {
            medium: 700,
            small: 400,
          },
        }
        let measures = [
          { fontSize: '18px', padding: '14px 46px', type: 'medium' },
          { fontSize: '14px', padding: '10px 28px', type: 'small' },
        ]
        btnPaddings = {
          mediaQueries: `
          @media (max-width: ${sizes.width.medium}px) {
              .buttonConfig {
                padding: ${measures[0].padding} !important;
                font-size: ${measures[0].fontSize} !important;
              }
            }
            @media (max-width: ${sizes.width.small}px) {
              .buttonConfig {
                padding: ${measures[1].padding} !important;
                font-size:${measures[1].fontSize} !important;
              }
        }
        `,
        }
      }
      if (btnSizeType === 'large') {
        let sizes = {
          width: {
            medium: 700,
            small: 400,
          },
        }
        let measures = [
          { fontSize: '20px', padding: '18px 56px', type: 'medium' },
          { fontSize: '16px', padding: '14px 36px', type: 'small' },
        ]
        btnPaddings = {
          mediaQueries: `
          @media (max-width: ${sizes.width.medium}px) {
            .buttonConfig {
              padding: ${measures[0].padding} !important;
              font-size: ${measures[0].fontSize} !important;
            }
        }
        @media (max-width: ${sizes.width.small}px) {
          .buttonConfig {
            padding: ${measures[1].padding} !important;
            font-size:${measures[1].fontSize} !important;
          }
        }
        `,
        }
      }
      return btnPaddings
    },
    async handlePublishNewCta() {
      try {
        if (this.beingEditedCtaId) {
          return this.handleUpdateCta()
        }
        this.loadings.creatingCta = true
        const generatedCtas = this.generateCta()

        const ret = await playerApi.addOutsideCta(this.video.id, generatedCtas)
        this.video.config = ret.data
        this.UPDATE_VIDEO(this.video)
        this.ctaButtons = ret.data.ctas ?? []

        this.outsideCtaButtons = ret.data.outsideCta ?? []

        this.wasSomethingChanged = false
        this.handleGetBack()
        this.loadings.creatingCta = false
        this.error = ''
        this.initialAppendWebsite = this.editingButton.appendWebsiteQueryParams
      } catch (error) {
        this.error = this.$t('message.pages.video.buttonsPage.errors.addError')
        this.loadings.creatingCta = false
        console.log(error)
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    resetFormData() {
      this.initialEditingCtaValue = {}
      this.beingEditedCtaId = ''
      this.editingButton = {
        title: this.$t('message.pages.video.button'),
        link: '',
        startTime: '00:00',
        endTime: '00:05',
        selectedButtonType: 'underVideo',
        textColor: '#FFFFFF',
        textHover: '#FFFFFF',
        backgroundColor: '#3e50f7',
        backgroundHover: '#3e50f7',
        selectedButtonSize: 'small',
        selectedButtonPlacement: 'midCenter',
        isCustomHtml: false,
        codeHtml: '',
        lastAllVideo: this.containButton.length ? false : true,
        lastTillEnd: false,
        keepWindow: false,
        appendWebsiteQueryParams: false,
      }
      this.player = null
      this.openModalExceptTime = false
      this.wasSomethingChanged = false
    },
    handleChangeButtonPlacement(placement) {
      this.editingButton.selectedButtonPlacement = placement
      this.setIframeConfig()
    },
    async handleUpdateCta() {
      try {
        this.loadings.updatingCta = true

        await playerApi.deleteOutsideCta(this.video.id, this.beingEditedCtaId)

        this.beingEditedCtaId = ''
        const generatedCtas = this.generateCta()
        const ret = await playerApi.addOutsideCta(this.video.id, generatedCtas)

        this.video.config = ret.data
        this.UPDATE_VIDEO(this.video)
        this.ctaButtons = ret.data.ctas ? ret.data.ctas : []
        this.outsideCtaButtons = ret.data.outsideCta ? ret.data.outsideCta : []

        this.wasSomethingChanged = false
        this.handleGetBack()

        this.loadings.updatingCta = false
        this.error = ''
      } catch (error) {
        this.error = this.$t(
          'message.pages.video.buttonsPage.errors.updateError'
        )
        this.loadings.updatingCta = false
        console.log(error)
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    generateCta() {
      if (!this.beingEditedCtaId || this.beingEditedCtaId === '') {
        const id = uuidv4()
        this.beingEditedCtaId = id
      }
      let buttonConfig = this.editingButton
      let time = this.formatTimeToSeconds(this.editingButton.startTime)
      let duration =
        this.formatTimeToSeconds(this.editingButton.endTime) -
        this.formatTimeToSeconds(this.editingButton.startTime)

      if (duration < 1) {
        duration = 0
      }

      if (this.editingButton.lastAllVideo) {
        time = 0
        duration = this.timeVideo
      }
      if (this.editingButton.lastTillEnd) {
        duration = this.timeVideo
      }
      const cta = {
        id: this.beingEditedCtaId,
        title: this.editingButton.title,
        type: 'video',
        time: time,
        script: this.generateOutsideButtonScriptStyle(),
        duration: duration,
        scriptForPast: this.editingButton.isCustomHtml
          ? this.editingButton.codeHtml
          : this.generateOutsideButtonScript(),
        metadata: this.editingButton,
      }

      if (this.editingButton.isCustomHtml) {
        cta.metadata.appendWebsiteQueryParams = false
      }

      if (cta.metadata.selectedButtonType === 'underVideo') {
        cta['divId'] = this.initialEditingCtaValue?.divId ?? uuidv4()
      }

      cta.scriptForPast += `ipt><div id="${cta.divId}"></div>`
      return cta
    },

    handleGetBack(setModal = false) {
      this.beingEditedCtaId = ''
      if (!this.isEditing) this.resetFormData()
      if (this.isEditing) {
        this.isEditing = false
      }
      const iframe =
        document.getElementById('preview-iframe')?.contentWindow.document ||
        document.getElementById('preview-iframe')?.contentDocument
      if (iframe) {
        iframe.open()
        iframe.write('')
        iframe.close()
      }
      this.openModal = setModal
      if (!setModal) this.handleUpdateVideo()
    },
    handleLastAllVideo() {
      if (this.editingButton.lastAllVideo) {
        this.editingButton.startTime = this.getDefaultTimes().start
        this.editingButton.endTime = this.formatSecondsToTime(this.timeVideo)
        this.editingButton.lastTillEnd = false
        this.openModalExceptTime = false
        this.setIframeConfig()
      }
    },
    handleOpenModalExceptTime(change) {
      this.openModalExceptTime = change
      if (change) {
        this.editingButton.lastAllVideo = false
      }
    },
    handleLastTillEnd() {
      if (this.editingButton.lastTillEnd) {
        this.editingButton.endTime = this.formatSecondsToTime(this.timeVideo)
        this.editingButton.lastAllVideo = false
        this.setIframeConfig()
      }
    },
    getDefaultTimes() {
      if (this.timeVideo && this.timeVideo >= 3600) {
        return {
          start: '00:00:00',
          end: '00:05:00',
        }
      }
      return {
        start: '00:00',
        end: '00:05',
      }
    },
    blockingEndTime() {
      let endTimeValues = this.editingButton.endTime.split(':').map(Number)
      let startTimeValues = this.editingButton.startTime.split(':').map(Number)

      if (endTimeValues.length === 2) endTimeValues.unshift(0)
      if (startTimeValues.length === 2) startTimeValues.unshift(0)
      let minEndTimeValues = startTimeValues

      if (endTimeValues[1] > startTimeValues[1]) {
        minEndTimeValues[2] = 0
      }
      if (endTimeValues[0] > startTimeValues[0]) {
        minEndTimeValues[1] = 0
      }
      const minEndTimeString = minEndTimeValues
        .map((val) => String(val).padStart(2, '0'))
        .join(':')

      return minEndTimeString
    },
    discardChanges() {
      this.wasSomethingChanged = false
      if (!this.isEditing) this.handleGetBack(true)
      else this.editingButton = _.cloneDeep(this.initialEditingButton)
      this.handleGetBack()
    },
  },
}
</script>

<style scoped lang="scss">
.redirectLink {
  color: varFigma(neutral-30-base) !important;
}
.color-back {
  color: varFigma(brand-60-base) !important;
}
.neutral-20-dark-text {
  color: varFigma(neutral-20-dark) !important;
}
::v-deep .hide-icon-time-picker {
  width: 52px;
}
::v-deep .hide-icon-time-picker > .ant-time-picker-icon {
  display: none;
}
.border-rounded-circle {
  border: 1px solid varFigma(neutral-95-lightest);
}
.rounded-circle {
  background: varFigma(neutral-80-lighter);
}
.rounded-circle:hover {
  background-color: grey; /* Cor ao passar o mouse */
}
.actionsBtns {
  position: sticky;
  bottom: -1px;
  width: 100%;
  z-index: 999;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: varFigma(neutral-100-white);
  border-top: 1px solid varFigma(neutral-95-lightest);
}
.dialogIframe {
  position: sticky;
  top: -1px;
  width: 100%;
  z-index: 999;
  background: varFigma(neutral-100-white);
}
::v-deep .error-timer input {
  border-color: varFigma(feedback-danger-light) !important;
  background-color: varFigma(feedback-danger-background) !important;
  color: varFigma(feedback-danger) !important;
}
.error_text {
  color: varFigma(feedback-danger) !important;
}
</style>
